import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\TemplateDashboard\UnsubscribeToTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UnsubscribeToTemplateDashboardController.php
* @route '/api/template-dashboard/unsubscribe'
*/
const UnsubscribeToTemplateDashboardController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnsubscribeToTemplateDashboardController.url(options),
    method: 'post',
})

UnsubscribeToTemplateDashboardController.definition = {
    methods: ["post"],
    url: '/api/template-dashboard/unsubscribe',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\TemplateDashboard\UnsubscribeToTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UnsubscribeToTemplateDashboardController.php
* @route '/api/template-dashboard/unsubscribe'
*/
UnsubscribeToTemplateDashboardController.url = (options?: RouteQueryOptions) => {
    return UnsubscribeToTemplateDashboardController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\TemplateDashboard\UnsubscribeToTemplateDashboardController::__invoke
* @see app/Http/Controllers/TemplateDashboard/UnsubscribeToTemplateDashboardController.php
* @route '/api/template-dashboard/unsubscribe'
*/
UnsubscribeToTemplateDashboardController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: UnsubscribeToTemplateDashboardController.url(options),
    method: 'post',
})

export default UnsubscribeToTemplateDashboardController